const STEPS = {
  PROPOSAL_CREATED: 'Proposta criada',
  LOAN_PROPOSAL_ANALYSIS: 'Análise de crédito',
  DOCUMENTS_COLLATERAL_INSPECTION: 'Documentos e Vistoria',
  PRE_QUALIFICATION: 'Pré-qualificação',
  PROCESSING: 'Processando',
  REJECTED: 'Negado',
  PAID: 'Pago',
  PROCESSES_AND_DOCUMENTS: 'Processamento e documentos',
  CREDIT_ANALYSIS: 'Análise de crédito',
  COLLATERAL_INSPECTION: 'Vistoria',
  LEGAL_ANALYSIS: 'Análise jurídica',
  CONTRACT: 'Contrato',
  CONTRACT_REGISTRATION: 'Registro em cartório',
  LOAN_PAYMENT: 'Pagamento do empréstimo',
}

const AUTO_STEP_NAME = {
  PROPOSAL_CREATED: 'PROPOSAL_CREATED',
  PRE_QUALIFICATION: 'PRE_QUALIFICATION',
  PROCESSING: 'PROCESSING',
  LOAN_PROPOSAL_ANALYSIS: 'LOAN_PROPOSAL_ANALYSIS',
  DOCUMENTS: 'DOCUMENTS',
  COLLATERAL_INSPECTION: 'COLLATERAL_INSPECTION',
  CONTRACT: 'CONTRACT',
  LOAN_PAYMENT: 'LOAN_PAYMENT',
  DOCUMENTS_COLLATERAL_INSPECTION: 'DOCUMENTS_COLLATERAL_INSPECTION',
}

const AUTO_STEPS_LIST = {
  PROPOSAL_CREATED: 'Proposta criada',
  PRE_QUALIFICATION: 'Pré-qualificação',
  PROCESSING: 'Processando',
  LOAN_PROPOSAL_ANALYSIS: 'Análise de crédito',
  DOCUMENTS_COLLATERAL_INSPECTION: 'Documentos e Vistoria',
  CONTRACT: 'Contrato',
  LOAN_PAYMENT: 'Pagamento do empréstimo',
}

const HOME_STEPS_LIST = {
  PROPOSAL_CREATED: 'Proposta criada',
  PRE_QUALIFICATION: 'Pré-qualificação',
  LOAN_PROPOSAL_ANALYSIS: 'Análise de crédito',
  LOAN_PAYMENT: 'Pagamento do empréstimo',
}

const HOME_STEPS_BCREDI_LIST = {
  PROPOSAL_CREATED: 'Proposta criada',
  PRE_QUALIFICATION: 'Pré-qualificação',
  PROCESSES_AND_DOCUMENTS: 'Processamento e documentos',
  CREDIT_ANALYSIS: 'Análise de crédito',
  COLLATERAL_INSPECTION: 'Vistoria',
  LEGAL_ANALYSIS: 'Análise jurídica',
  CONTRACT: 'Contrato',
  CONTRACT_REGISTRATION: 'Registro em cartório',
  LOAN_PAYMENT: 'Pagamento do empréstimo',
}

const HOME_FIN_STEPS = {
  Cadastro: 'Cadastro',
  'Simulação de crédito': 'Simulação de crédito',
  'Análise de crédito': 'Análise de crédito',
  'Análise jurídica': 'Análise jurídica',
  'Contratação e assinatura': 'Contratação e assinatura',
  'Registro dos contratos no cartório': 'Registro dos contratos no cartório',
  'Liberação do recurso de financiamento':
    'Liberação do recurso de financiamento',
  'Processos descontinuados': 'Processos descontinuados',
}

const AUTO_STEPS = Object.keys(AUTO_STEPS_LIST)
const HOME_STEPS = Object.keys(HOME_STEPS_LIST)
const HOME_STEPS_BCREDI = Object.keys(HOME_STEPS_BCREDI_LIST)

export {
  STEPS,
  AUTO_STEPS_LIST,
  AUTO_STEPS,
  HOME_STEPS_LIST,
  HOME_STEPS,
  AUTO_STEP_NAME,
  HOME_STEPS_BCREDI_LIST,
  HOME_STEPS_BCREDI,
  HOME_FIN_STEPS,
}
